import { useLocation } from "react-router";
import { RouteFactory } from "@app/routePaths";

const Favicon = (): React.ReactElement => {
  const { pathname } = useLocation();

  if (pathname.startsWith(RouteFactory.thrive)) {
    return (
      <>
        <link rel="icon" href="/logo-favicon-thrive.png" type="image/png" />
        <link rel="mask-icon" href="/logo-favicon-thrive.png" color="#000000" />
      </>
    );
  }

  return (
    <link
      href="/favicon.ico"
      rel="icon"
      type="image/x-icon"
      id="favicon-link"
    />
  );
};

export default Favicon;
